/* istanbul ignore file */
import { FC } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { translate } from 'containers/services/translate';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import { COLORS } from 'constants/design';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import victimIcon from 'images/victim-icon.svg';
import { TUTOR } from 'containers/data-structure';

export interface TutorInfoProps {
  intl: IntlShape;
  tutorInfo: any;
}

const TutorInfo: FC<TutorInfoProps> = props => {
  const { tutorInfo } = props;

  return (
    <CustomAccordion
      title={translate({ ...messages.tutorTitle }, props)}
      textColor={COLORS.ACCORDION_TEXT_BLUE}
      bgColor={COLORS.ACCORDION_BG_BLUE}
      image={victimIcon}
    >
      <Grid container direction="row" spacing={3} alignItems="center">
        <Grid item xs={4}>
          <TextField
            label={translate({ ...messages.victimCin }, props)}
            className="input"
            name={TUTOR.CIN}
            fullWidth
            value={get(tutorInfo, [TUTOR.CIN])}
            InputProps={{ inputProps: { maxlength: 20 } }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            label={translate({ ...messages.victimFirstName }, props)}
            className="input"
            fullWidth
            name={TUTOR.FIRST_NAME}
            value={get(tutorInfo, [TUTOR.FIRST_NAME])}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            label={translate({ ...messages.victimLastName }, props)}
            className="input"
            fullWidth
            name={TUTOR.LAST_NAME}
            value={get(tutorInfo, [TUTOR.LAST_NAME])}
          />
        </Grid>
      </Grid>
    </CustomAccordion>
  );
};

export default injectIntl(TutorInfo);
